// Round 3 Lane 5 copy: Plus membership (R-46) and affiliate links (R-47). Opus draft, Astra pass: Astra was not part of this
// lane, so Opus drafted and Claude gated (AGENTS.md: "If Astra is unavailable, Opus covers"). Sentence case, no dashes or
// exclamation marks, "activities" not "listings", the price comes from Stripe (never typed here), and nothing is promised
// that is not built. The three "what Plus gets you" lines are the same ones the Plus offer card already shows
// (copyFeatGrowth fg.plus_item_1..3), so the offer and the join screen never disagree.
export const RM = {
  // Settings: join
  'rm.kicker': 'Magellan Plus',
  'rm.title': 'Join Magellan Plus',
  'rm.body': 'Browsing, plans and your calendar stay free. Plus adds a few conveniences.',
  'rm.price': '{price} a {interval}. Cancel any time.',
  'rm.join': 'Join Plus',
  'rm.joining': 'Opening checkout',
  'rm.sign_in_first': 'Sign in first so your membership stays with your account.',
  'rm.sign_in': 'Sign in',
  'rm.secure_note': 'Payment happens on Stripe’s secure page. Magellan never sees your card.',
  // Settings: member
  'rm.member_title': 'You’re a Plus member',
  'rm.member_renews': 'Renews on {date}.',
  'rm.member_ends': 'Your membership ends on {date}. Nothing more will be charged.',
  'rm.member_past_due': 'Your last payment did not go through. Update your card to keep Plus.',
  'rm.manage': 'Manage or cancel',
  'rm.opening': 'Opening',
  // Back from Stripe
  'rm.back_joined': 'Thanks for joining. It can take a few seconds to show here.',
  'rm.back_cancelled': 'No charge was made.',
  // Errors
  'rm.error': 'That did not work. Please try again.',
  'rm.unavailable': 'Plus is not open yet.',
  // R-47: the disclosure next to an affiliate link (FTC: clear, next to the link, before the click)
  'rm.affiliate_note': 'Magellan may earn a small commission if you buy through this link. It never changes what we show you or in what order.',
} as const

export type RmKey = keyof typeof RM
/** A Lane 5 line, with {placeholders} filled. */
export const rm = (k: RmKey, vars: Record<string, string | number> = {}): string =>
  RM[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
